import { cn } from "@/lib/utils";

import type { FacetOption } from "./facet-option-list";

export function facetOptionRowClassName(
  item: FacetOption,
  isActive: boolean,
  disabled: boolean,
): string {
  const columns = item.icon
    ? "grid-cols-[auto_minmax(0,1fr)_auto]"
    : "grid-cols-[minmax(0,1fr)_auto]";
  if (isActive) {
    return cn(
      "relative min-h-10 w-full overflow-hidden rounded-lg border px-2.5 pt-1.5 pb-2.5 text-left transition-colors grid items-center gap-2",
      columns,
      "border-primary/60 bg-primary/10 text-foreground",
    );
  }
  if (disabled) {
    return cn(
      "relative min-h-10 w-full overflow-hidden rounded-lg border px-2.5 pt-1.5 pb-2.5 text-left transition-colors grid items-center gap-2",
      columns,
      "border-border/50 bg-secondary/30 text-muted-foreground/40 cursor-not-allowed",
    );
  }
  return cn(
    "relative min-h-10 w-full overflow-hidden rounded-lg border px-2.5 pt-1.5 pb-2.5 text-left transition-colors grid items-center gap-2",
    columns,
    "border-border bg-secondary/50 text-muted-foreground hover:border-border/80 hover:text-foreground",
  );
}
